import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { AuthState } from '@/modules/auth/types';

const state: AuthState = {
    token: localStorage.getItem('token') || '',
    refresh_token: localStorage.getItem('refresh_token') || '',
    user: undefined,
    account: {
        moneyCurrency: 'GCC',
        moneyAmount: '0'
    },
    error: false,
    loading: false
};

export const auth = {
    state,
    getters,
    mutations,
    actions,
};
